import React from 'react';
import './TermsModel.css';

const TermsModel = ({ show, onClose }) => {
  if (!show) return null;

  return (
    <div className="terms-model-overlay" onClick={onClose}>
      <div className="terms-model-content" onClick={(e) => e.stopPropagation()}>
        <div className="terms-model-header">
          <h2>Terms & Conditions</h2>
          <button className="terms-model-close" onClick={onClose}>
            ×
          </button>
        </div>
        
        <div className="terms-model-body">
          <div className="terms-section">
            <h3>1. Acceptance of Terms</h3>
            <p>By accessing or using ResumeGlobe, you agree to be bound by these Terms & Conditions and our Privacy policy which explains how we collect, use, and protect your personal data. If you do not agree, please do not use the platform.</p>
          </div>

          <div className="terms-section">
            <h3>2. Eligibility</h3>
            <p>You must be at least 18 years old or have parental consent to use our services. By using ResumeGlobe, you represent that you have the legal capacity to enter into these terms.</p>
          </div>

          <div className="terms-section">
            <h3>3. Account & Login</h3>
            <p>To access certain features, you may need to create an account. You are responsible for maintaining the confidentiality of your login credentials and for all activities that occur under your account. Notify us immediately of any unauthorized access.</p>
          </div>

          <div className="terms-section">
            <h3>4. Use of Services</h3>
            <p>ResumeGlobe provides resume building, cover letter creation, and career enhancement tools. You may use our services for personal, non-commercial purposes in accordance with these terms. Commercial use requires prior written permission.</p>
          </div>

          <div className="terms-section">
            <h3>5. Resume Storage</h3>
            <p>We securely store your resume data using industry-standard encryption. While we take reasonable measures to protect your information, you should maintain your own backup copies of important documents. We are not liable for any data loss.</p>
          </div>

          <div className="terms-section">
            <h3>6. Payments & Refunds</h3>
            <p>Subscription fees are charged according to your selected plan. All payments are processed securely through our payment partners. Refunds are subject to our separate Refund Policy.</p>
          </div>

          <div className="terms-section">
            <h3>7. User Responsibilities</h3>
            <p>You agree to provide accurate information, use our services lawfully, respect intellectual property rights, and maintain the security of your account. You are responsible for the content you create and upload to our platform.</p>
          </div>

          <div className="terms-section">
            <h3>8. Prohibited Activities</h3>
            <p>You may not: violate any laws, infringe on others' rights, upload malicious content, attempt to hack or disrupt our services, share account credentials, or use our platform for spam or fraudulent activities.</p>
          </div>

          <div className="terms-section">
            <h3>9. Intellectual Property</h3>
            <p>ResumeGlobe owns all rights to our platform, software, templates, and proprietary content. You retain rights to your personal resume content. By using our templates, you receive a limited license to create resumes for personal use.</p>
          </div>

          <div className="terms-section">
            <h3>10. Termination</h3>
            <p>Either party may terminate your account at any time. We may suspend or terminate accounts for violations of these terms. Upon termination, your right to use our services ceases, though these terms remain applicable to prior use.</p>
          </div>

          <div className="terms-section">
            <h3>11. Limitation of Liability</h3>
            <p>ResumeGlobe's liability is limited to the amount you paid for our services in the 12 months preceding any claim. We are not liable for indirect, incidental, or consequential damages, including but not limited to lost profits or employment opportunities.</p>
          </div>

          <div className="terms-section">
            <h3>12. Governing Law</h3>
            <p>These terms are governed by the laws of the jurisdiction where ResumeGlobe is incorporated. Any disputes will be resolved through binding arbitration or in the courts of that jurisdiction.</p>
          </div>

          <div className="terms-section">
            <h3>13. Contact</h3>
            <p>For questions about these Terms & Conditions, please contact us at:</p>
            <p><strong>Email:</strong> support@resumeglobe.com</p>
            <p><strong>Last Updated:</strong> October 24, 2025</p>
          </div>
        </div>
        
        <div className="modal-footer">
          <button className="btn-close-modal" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
};

export default TermsModel;